var radio = require("react-pubsub-via-radio.js/radio");
var _ = require('lodash');
var Ajax = require('./Ajax');
var JSONP = require('browser-jsonp');

var balboa_prefix = '/balboa3';
var extend_with_params = {};
var init = function(config){
	if(_.isObject(config)){
		if(_.isObject(config.extend_with_params)){
			extend_with_params = _.cloneDeep(config.extend_with_params);
		}
		if(_.isString(config.balboa_prefix)){
			balboa_prefix = config.balboa_prefix;
		}
	}
};

var extend_with_balboa_params = function(params_orig){
	var params = _.cloneDeep(_.isObject(params_orig) ? params_orig : {});
	params = _.extend(params, extend_with_params);
	return params;
};

var api = function(uri, params, callback, errorCallback, onProgress){
	if(!uri){
		return null;
	}
	callback = _.isFunction(callback) ? callback : _.noop;
	errorCallback = _.isFunction(errorCallback) ? errorCallback : _.noop;

	params = extend_with_balboa_params(params);

	return Ajax.post(balboa_prefix + uri, params, function(err, data, status_code, xhr){
		if(!err){
			try{
				data = JSON.parse(data);
			}catch(e){
			}
			if(data.success === true){
				callback(data, err, status_code, xhr);
				return;
			}
		}
		if(data && data.authenticationerror){
			radio('Balboa_authenticationerror').broadcast(data);
		}
		errorCallback(data, err, status_code, xhr);
	}, onProgress);
};


module.exports.init = init;
module.exports.api = api;
module.exports.jsonp = function(url, params, onSuccess, onFailure){
	JSONP({
		url: balboa_prefix + url,
		data: extend_with_balboa_params(params),
		success: function(data){
			if(data && data.success){
				onSuccess(data);
			}else{
				if(data && data.authenticationerror){
					radio('Balboa_authenticationerror').broadcast(data);
				}
				onFailure(data);
			}
		},
		error: onFailure
	});
};
module.exports.extend_with_balboa_params = extend_with_balboa_params;
module.exports.get_balboa_upload_url = function(url){
	return 'https://www.espeakers.com/balboa3' + url;
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/services/Balboa.js
// module id = 20
// module chunks = 0 1 2 3 4